import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchJobRequest } from "../actions/job";
import JobForm from "../components/JobForm";

class JobContainer extends PureComponent {
  componentDidMount = () => {
    const { endpoint, jobId } = this.props;

    if (!!jobId) {
      this.props.fetchJobRequest(endpoint, jobId);
    }
  }

  render() {
    const { isFetching, jobId, endpoint } = this.props;
    return <JobForm fetchJobRequest={this.props.fetchJobRequest} isFetching={isFetching} jobId={jobId} endpoint={endpoint} />;
  }
}

JobContainer.propTypes = {
  jobId: PropTypes.string,
  endpoint: PropTypes.string,
  isFetching: PropTypes.bool,
  fetchJobRequest: PropTypes.func.isRequired,
};

function mapStateToProps({ jobReducer: { isFetching } }) {
  return { isFetching };
}

export default connect(mapStateToProps, { fetchJobRequest })(JobContainer);



// WEBPACK FOOTER //
// ./src/containers/JobContainer.js